<template>
  <div v-if="schemaFields">
    <form>
      <div v-for="field in schemaFields" :key="field.$$hashKey">
        <div class="row" v-if="field.type=='number'">
          <div class="col-md-12 col-12 form-group">
            <label>{{field.displayName}}</label>
            <el-input type="number" v-model="field.value" :disabled="readOnly"></el-input>
          </div>
        </div>
        <!-- added missing input type textarea -->
        <div class="row" v-if="field.type=='textarea'">
          <div class="col-md-12 col-12 form-group">
            <label>{{field.displayName}}</label>
            <el-input type="textarea"  v-model="field.value" :placeholder="field.placeholder" :disabled="readOnly"></el-input>
          </div>
        </div>

        <div class="row" v-if="field.type=='text' || field.type == 'email'">
          <div class="col-md-12 col-12 form-group">
            <label>{{field.displayName}}</label>
            <el-input type="text" v-model="field.value" :disabled="readOnly"></el-input>
          </div>
        </div>

        <div class="row" v-if="field.type=='selectlist'">
          <div class="col-md-12 col-12 form-group">
            <label for="ScreeingPhase">{{field.displayName}}</label>
            <el-select class="select-primary" size="large" :name="field.name" :placeholder="field.displayName" v-model="selectListModels[field.name]" :disabled="readOnly" v-if="!readOnly">
              <el-option disabled value>{{field.displayName}}</el-option>
              <el-option v-for="option in field.options" :key="option.value" class="select-primary" :value="option.value" :label="option.text"></el-option>
            </el-select>
          </div>
          <div class="col-md-12 col-12 form-group" v-if="readOnly">
            <div class="select-list-selected-view">{{ getSelectedOption(field).text }}</div>
          </div>
        </div>

        <div class="row" v-if="field.type=='radiobuttonlist'">
          <label class="col-md-12 col-form-label">{{field.displayName}}</label>
          <div class="col-md-12" v-for="option in field.options" :key="option.value">
            <n-radio :label="option.value" v-model="field.value" :disabled="readOnly" v-if="!readOnly">{{option.text}}</n-radio>
            <n-radio :label="option.value" :value="field.value" :disabled="readOnly" v-if="readOnly">{{option.text}}</n-radio>
          </div>
        </div>

        <div class="row" v-if="field.type == 'checkboxlist'">
          <label class="col-md-12 col-form-label">{{field.displayName}}</label>
          <div class="col-md-12" v-for="(option, index) in field.options" :key="option.value" @click.prevent>
            <checkbox :checked="field.value[index]" :ref="'checklist-' + field.name + '-' + option.value" @click.native="check(field, index, option)">{{option.text}}</checkbox>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import { Select, Option } from "element-ui";
import { Checkbox, Radio } from "src/components/index";
export default {
  name: "form-renderer",

  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    Checkbox,
    "n-radio": Radio,
  },
  data() {
    return {
      selectListModels: {},
      fields: [],
    };
  },

  mounted() {
    if (!this.readOnly) {
      let schema =
        typeof this.schema === "string" ? JSON.parse(this.schema) : this.schema;


      this.fields = schema.fields;
    }
  },

  computed: {
    schemaFields() {
      if (this.readOnly) {
        let schema =
          typeof this.schema === "string"
            ? JSON.parse(this.schema)
            : this.schema;
        if (schema && schema.fields) {
          return schema.fields;
        } else {
          return [];
        }
      } else {
        return this.fields;
      }
    },
  },

  methods: {
    check(field, index, option) {
      if (field.value[index]) {
        field.value[index] = false;
        this.$refs[
          "checklist-" + field.name + "-" + option.value
        ][0].checked = false;
      } else {
        field.value[index] = true;
        this.$refs[
          "checklist-" + field.name + "-" + option.value
        ][0].checked = true;
      }
    },
    isChecked(fieldName, option) {
      console.log(this.model[fieldName]);
    },
    getSelectedOption(field) {
      return field.options.find((option) => {
        return option.value == field.value;
      });
    },
    getData() {
      return { fields: this.fields };
    },
  },
  props: {
    schema: {
      default() {
        return {
          fields: [],
        };
      },
    },
    model: {},
    readOnly: {},
  },

  watch: {

    selectListModels: {
      handler() {
        this.schema.fields.forEach((field) => {
          if (field.type == "selectlist") {
            field.value = this.selectListModels[field.name];
          }
        });
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.select-list-selected-view {
  font-weight: 400;
  font-size: 0.8571em;
  line-height: 1.35em;
  border-radius: 30px;
  border: 1px solid #e3e3e3 !important;
  padding: 11px 22px;
}
/deep/ .form-check.disabled .form-check-label,
.form-check.disabled .form-check-label {
  color: inherit;
  opacity: inherit;
}
/deep/input.el-input__inner {
  border: 1px solid #e3e3e3 !important;
}
</style>
